// import { ref, computed } from "vue";
import { defineStore } from 'pinia'

import { userState } from '@/stores/userstore/userState.js'
import { userGetters } from '@/stores/userstore/userGetters.js'
import { userActions } from '@/stores/userstore/userActions.js'

export const userStore = defineStore('userstore', {
  state: () => userState,
  getters: userGetters,
  actions: userActions
})

export default userStore
